export default __webpack_public_path__ + "static/media/frida.9cea0db8.jpg";